import {Dialog, Slide, useMediaQuery} from '@material-ui/core'
import {TransitionProps} from '@material-ui/core/transitions/transition'
import {Fade as Hamburger} from 'hamburger-react'
import React, {ReactElement, useEffect} from 'react'
import {MainUrlTypes} from '../../../types'
import {style} from '../../../util/style'
import {CartIcon} from '../../webshop/layout/cart/CartIcon'

const styles = style('headerpopup')

export const HeaderPopup: React.FC<{
	project_key?: string
	main_pages?: Array<MainUrlTypes>
	toggled: boolean
	toggle: (state: boolean) => void
}> = ({project_key, main_pages, toggled, toggle, children}) => {
	const isMobile = useMediaQuery('(max-width:1024px)')

	useEffect(() => {
		const bodyStyle = document.body.style
		if (toggled) bodyStyle.overflowY = 'hidden'
		else bodyStyle.overflowY = 'auto'
		if (!isMobile) toggle(false)
	}, [toggled, isMobile])

	return (
		<>
			{project_key === 'webshop' && (
				<CartIcon project_key={project_key} main_pages={main_pages} />
			)}
			<Hamburger
				toggle={toggle}
				toggled={toggled}
				color={'#61C250'}
				distance={'sm'}
				label="toggle-mobile-menu"
			/>
			<Dialog
				open={toggled}
				TransitionComponent={TransitionComponent}
				onClose={() => toggle(false)}
				BackdropComponent={null}
				// Height of header
				style={{top: project_key === 'webshop' ? 61 : 49}}
				hideBackdrop
				fullScreen
				classes={{
					root: styles('root').toString(),
					paper: styles('paper').toString()
				}}
			>
				{children}
			</Dialog>
		</>
	)
}

export const TransitionComponent: React.ComponentType<TransitionProps> = React.forwardRef(
	function Transition(props, ref) {
		return (
			<Slide
				direction="left"
				ref={ref}
				{...props}
				children={props.children as ReactElement}
			/>
		)
	}
)
